module.exports = __webpack_public_path__ + "static/media/charlies.3b1f9772.svg";